(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["back-to-top"] && !Shopify.designMode) return;
  try {
    (function() {
    var btn = document.querySelector('[data-back-to-top]');
    if (!btn) return;

    var threshold = 400;

    window.addEventListener('scroll', function() {
      if (window.scrollY > threshold) {
        btn.hidden = false;
        requestAnimationFrame(function() {
          btn.classList.add('back-to-top--visible');
        });
      } else {
        btn.classList.remove('back-to-top--visible');
        btn.addEventListener('transitionend', function handler() {
          if (!btn.classList.contains('back-to-top--visible')) {
            btn.hidden = true;
          }
          btn.removeEventListener('transitionend', handler);
        });
      }
    }, { passive: true });

    btn.addEventListener('click', function() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-toast"] && !Shopify.designMode) return;
  try {
    (function() {
    var toast = document.querySelector('[data-cart-toast]');
    if (!toast) return;

    var imageEl = toast.querySelector('[data-cart-toast-image]');
    var titleEl = toast.querySelector('[data-cart-toast-title]');
    var priceEl = toast.querySelector('[data-cart-toast-price]');
    var closeBtn = toast.querySelector('[data-cart-toast-close]');
    var timer = null;

    function show(detail) {
      if (titleEl) titleEl.textContent = detail.title || '';
      if (priceEl) priceEl.textContent = detail.price || '';
      if (imageEl) {
        if (detail.image) {
          imageEl.src = detail.image;
          imageEl.alt = detail.title || '';
          imageEl.style.display = '';
        } else {
          imageEl.style.display = 'none';
        }
      }

      toast.hidden = false;
      requestAnimationFrame(function() {
        toast.classList.add('cart-toast--visible');
      });

      clearTimeout(timer);
      timer = setTimeout(hide, 4000);
    }

    function hide() {
      toast.classList.remove('cart-toast--visible');
      clearTimeout(timer);
      setTimeout(function() {
        toast.hidden = true;
      }, 300);
    }

    closeBtn.addEventListener('click', hide);

    document.addEventListener('cart:item-added', function(e) {
      show(e.detail || {});
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-filters"] && !Shopify.designMode) return;
  try {
    (function() {
    var form = document.querySelector('[data-collection-filters]');
    if (!form) return;

    form.addEventListener('submit', function(e) {
      e.preventDefault();

      var action = form.getAttribute('action') || window.location.pathname;
      var params = new URLSearchParams(window.location.search);
      var named = form.querySelectorAll('input[name]');
      var owned = new Set();

      named.forEach(function(input) {
        owned.add(input.name);
      });

      Array.from(params.keys()).forEach(function(key) {
        if (key === 'page' || key.indexOf('filter.') === 0 || owned.has(key)) {
          params.delete(key);
        }
      });

      named.forEach(function(input) {
        if (input.type === 'checkbox' && !input.checked) return;
        if (!input.value) return;
        params.append(input.name, input.value);
      });

      var query = params.toString();
      window.location.href = query ? action + '?' + query : action;
    });

    form.querySelectorAll('[data-filter-search]').forEach(function(search) {
      search.addEventListener('input', function() {
        var query = this.value.toLowerCase();
        var list = this.nextElementSibling;
        if (!list) return;

        list.querySelectorAll('[data-filter-value]').forEach(function(item) {
          var label = item.getAttribute('data-filter-value');
          item.style.display = label.indexOf(query) === -1 ? 'none' : '';
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["currency-selector"] && !Shopify.designMode) return;
  try {
    class CurrencySelector extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.select = this.querySelector('[data-currency-selector-input]');
      if (!this.form || !this.select) return;

      this.select.addEventListener('change', () => this.form.submit());
      this.autoDetect();
    }

    autoDetect() {
      try {
        const STORAGE_KEY = 'ks_currency_autodetected_v1';
        if (localStorage.getItem(STORAGE_KEY)) return;
        localStorage.setItem(STORAGE_KEY, '1');

        const current = (this.dataset.currentCurrency || '').toUpperCase();
        const target = this.detectCurrencyFromTimezone();

        if (!target || target === current) return;

        const option = this.select.querySelector('option[data-currency="' + target + '"]');
        if (!option) return;

        this.select.value = option.value;
        this.form.submit();
      } catch (err) {
        /* fail silently: manual selection still works */
      }
    }

    detectCurrencyFromTimezone() {
      const tz = (Intl.DateTimeFormat().resolvedOptions().timeZone || '').trim();
      if (!tz) return null;

      if (tz.indexOf('Australia/') === 0) return 'AUD';
      if (tz === 'Pacific/Auckland' || tz === 'Pacific/Chatham') return 'NZD';

      const gbZones = [
        'Europe/London',
        'Europe/Belfast',
        'Europe/Guernsey',
        'Europe/Isle_of_Man',
        'Europe/Jersey'
      ];
      if (gbZones.indexOf(tz) !== -1) return 'GBP';

      if (tz.indexOf('Europe/') === 0 || tz === 'Atlantic/Canary' || tz === 'Atlantic/Madeira' || tz === 'Atlantic/Azores') {
        return 'EUR';
      }

      if (tz.indexOf('America/') === 0) return 'USD';

      return null;
    }
  }

  if (!customElements.get('currency-selector')) {
    customElements.define('currency-selector', CurrencySelector);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["info-tooltip"] && !Shopify.designMode) return;
  try {
    function positionInfoTooltip(tooltip) {
    var bubble = tooltip.querySelector('.info-tooltip__bubble');
    if (!bubble) return;
    var rect = tooltip.getBoundingClientRect();
    var iconCenter = rect.left + rect.width / 2;
    var bubbleWidth = bubble.offsetWidth || 220;
    var margin = 8;
    var preferredLeft = iconCenter - bubbleWidth / 2;
    var maxLeft = window.innerWidth - bubbleWidth - margin;
    var bubbleLeft = Math.max(margin, Math.min(preferredLeft, maxLeft));
    bubble.style.top = (rect.top - 8) + 'px';
    bubble.style.left = bubbleLeft + 'px';
    bubble.style.setProperty('--arrow-offset', (iconCenter - bubbleLeft) + 'px');
  }

  document.addEventListener('mouseover', function(event) {
    var t = event.target.closest && event.target.closest('[data-info-tooltip]');
    if (t) positionInfoTooltip(t);
  });

  document.addEventListener('focusin', function(event) {
    var t = event.target.closest && event.target.closest('[data-info-tooltip]');
    if (t) positionInfoTooltip(t);
  });

  document.addEventListener('click', function(event) {
    var t = event.target.closest('[data-info-tooltip]');
    if (!t) return;
    event.preventDefault();
    event.stopPropagation();
    positionInfoTooltip(t);
    t.focus();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card-list"] && !Shopify.designMode) return;
  try {
    (function() {
    function positionPclGoldTooltip(trigger) {
      var tip = trigger.querySelector('.pcl__gold-bubble');
      if (!tip) return;
      var rect = trigger.getBoundingClientRect();
      var center = rect.left + rect.width / 2;
      var width = tip.offsetWidth || 200;
      var margin = 8;
      var pref = center - width / 2;
      var max = window.innerWidth - width - margin;
      var left = Math.max(margin, Math.min(pref, max));
      tip.style.top = (rect.top - 8) + 'px';
      tip.style.left = left + 'px';
    }

    document.addEventListener('mouseover', function(event) {
      var t = event.target.closest && event.target.closest('.pcl__gold-icon[data-gold-tooltip]');
      if (t) positionPclGoldTooltip(t);
    });

    document.addEventListener('focusin', function(event) {
      var t = event.target.closest && event.target.closest('.pcl__gold-icon[data-gold-tooltip]');
      if (t) positionPclGoldTooltip(t);
    });

    function updateCartCount() {
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var countEl = document.querySelector('.header__cart-count');
          if (countEl) {
            countEl.textContent = cart.item_count;
          } else {
            var cartLink = document.querySelector('.header__cart');
            if (cartLink) {
              var span = document.createElement('span');
              span.className = 'header__cart-count';
              span.textContent = cart.item_count;
              cartLink.appendChild(span);
            }
          }
        });
    }

    document.querySelectorAll('.pcl').forEach(function(card) {
      var variants = card.querySelectorAll('[data-pcl-variant]');
      var priceEls = card.querySelectorAll('[data-pcl-price]');
      var btnEls = card.querySelectorAll('[data-pcl-btn]');
      var atcBtns = card.querySelectorAll('[data-pcl-add-to-cart]');

      /* Variant selection */
      variants.forEach(function(btn) {
        btn.addEventListener('click', function() {
          var id = this.getAttribute('data-variant-id');
          var price = this.getAttribute('data-variant-price');

          variants.forEach(function(v) { v.classList.remove('pcl__variant--selected'); });
          this.classList.add('pcl__variant--selected');

          priceEls.forEach(function(el) { el.textContent = price; });
          atcBtns.forEach(function(el) { el.setAttribute('data-variant-id', id); });

          btnEls.forEach(function(el) {
            if (el.tagName === 'A') {
              var href = el.href.split('?')[0];
              el.href = href + '?variant=' + id;
            }
          });
        });
      });

      /* AJAX add to cart */
      atcBtns.forEach(function(atcBtn) {
        atcBtn.addEventListener('click', function() {
          var variantId = this.getAttribute('data-variant-id');
          if (!variantId) return;

          var button = this;
          var originalText = button.textContent;
          button.disabled = true;
          button.textContent = '...';

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
          })
          .then(function(res) {
            if (!res.ok) return res.json().then(function(err) { throw err; });
            return res.json();
          })
          .then(function(data) {
            button.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" style="display:inline;vertical-align:middle;margin-right:4px"><path d="M3 8.5L6.5 12L13 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>Added';
            button.style.backgroundColor = '#38a169';
            setTimeout(function() {
              button.innerHTML = originalText;
              button.style.backgroundColor = '';
              button.disabled = false;
            }, 2000);
            updateCartCount();

            var cardEl = button.closest('.pcl');
            var imgEl = cardEl ? cardEl.querySelector('.pcl__image img') : null;
            var titleEl = cardEl ? cardEl.querySelector('.pcl__title') : null;
            var priceEl = cardEl ? cardEl.querySelector('[data-pcl-price]') : null;
            document.dispatchEvent(new CustomEvent('cart:item-added', { detail: {
              title: titleEl ? titleEl.textContent.trim() : '',
              image: imgEl ? imgEl.src : '',
              price: priceEl ? priceEl.textContent.trim() : ''
            }}));
          })
          .catch(function(err) {
            var errMsg = (err && (err.description || err.message)) || '';
            var isStock = errMsg.toLowerCase().indexOf('stock') > -1 ||
                          errMsg.toLowerCase().indexOf('cart') > -1 ||
                          errMsg.toLowerCase().indexOf('quantity') > -1 ||
                          errMsg.toLowerCase().indexOf('available') > -1;
            var msg = isStock ? 'All items in cart' : errMsg || 'All items in cart';
            button.textContent = msg;
            button.style.backgroundColor = isStock ? '#d69e2e' : '#e53e3e';
            setTimeout(function() {
              button.textContent = originalText;
              button.style.backgroundColor = '';
              button.disabled = false;
            }, 2500);
          });
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function() {
    function positionGoldTooltip(trigger) {
      var tip = trigger.querySelector('.product-card__gold-bubble');
      if (!tip) return;
      var rect = trigger.getBoundingClientRect();
      var center = rect.left + rect.width / 2;
      var width = tip.offsetWidth || 200;
      var margin = 8;
      var pref = center - width / 2;
      var max = window.innerWidth - width - margin;
      var left = Math.max(margin, Math.min(pref, max));
      tip.style.top = (rect.top - 8) + 'px';
      tip.style.left = left + 'px';
    }

    document.addEventListener('mouseover', function(event) {
      var t = event.target.closest && event.target.closest('[data-gold-tooltip]');
      if (t) positionGoldTooltip(t);
    });

    document.addEventListener('focusin', function(event) {
      var t = event.target.closest && event.target.closest('[data-gold-tooltip]');
      if (t) positionGoldTooltip(t);
    });

    document.addEventListener('click', function(event) {
      var t = event.target.closest && event.target.closest('[data-gold-tooltip]');
      if (!t) return;
      event.preventDefault();
      event.stopPropagation();
      positionGoldTooltip(t);
      t.focus();
    }, true);

    /* Variant select sync */
    document.querySelectorAll('[data-card-variant-select]').forEach(function(select) {
      select.addEventListener('change', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var card = this.closest('.product-card');
        if (!card) return;

        var variantId = this.value;
        var productUrl = this.getAttribute('data-product-url');

        /* Update add-to-cart button variant */
        var atcBtn = card.querySelector('[data-add-to-cart]');
        if (atcBtn) {
          atcBtn.setAttribute('data-variant-id', variantId);
        }

        /* Update preorder/backorder links */
        var button = card.querySelector('[data-card-button]');
        if (button && button.tagName === 'A' && productUrl) {
          button.href = productUrl + '?variant=' + variantId;
        }
      });

      select.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
      });
    });

    /* AJAX add to cart */
    document.querySelectorAll('.product-card [data-add-to-cart]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var variantId = this.getAttribute('data-variant-id');
        if (!variantId) return;

        var button = this;
        var originalText = button.textContent;
        button.disabled = true;
        button.textContent = '...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
        })
        .then(function(res) {
          if (!res.ok) return res.json().then(function(err) { throw err; });
          return res.json();
        })
        .then(function(data) {
          button.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" style="display:inline;vertical-align:middle;margin-right:4px"><path d="M3 8.5L6.5 12L13 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>Added';
          button.style.backgroundColor = '#38a169';
          setTimeout(function() {
            button.innerHTML = originalText;
            button.style.backgroundColor = '';
            button.disabled = false;
          }, 2000);

          var cardEl = button.closest('.product-card');
          var imgEl = cardEl ? cardEl.querySelector('img') : null;
          var titleEl = cardEl ? cardEl.querySelector('.product-card__title') : null;
          var priceEl = cardEl ? cardEl.querySelector('.product-card__price') : null;
          document.dispatchEvent(new CustomEvent('cart:item-added', { detail: {
            title: titleEl ? titleEl.textContent.trim() : '',
            image: imgEl ? imgEl.src : '',
            price: priceEl ? priceEl.textContent.trim() : ''
          }}));

          fetch('/cart.js')
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              var countEl = document.querySelector('.header__cart-count');
              if (countEl) {
                countEl.textContent = cart.item_count;
              } else {
                var cartLink = document.querySelector('.header__cart');
                if (cartLink) {
                  var span = document.createElement('span');
                  span.className = 'header__cart-count';
                  span.textContent = cart.item_count;
                  cartLink.appendChild(span);
                }
              }
            });
        })
        .catch(function(err) {
          var errMsg = (err && (err.description || err.message)) || '';
          var isStock = errMsg.toLowerCase().indexOf('stock') > -1 ||
                        errMsg.toLowerCase().indexOf('cart') > -1 ||
                        errMsg.toLowerCase().indexOf('quantity') > -1 ||
                        errMsg.toLowerCase().indexOf('available') > -1;
          var msg = isStock ? 'All items in cart' : errMsg || 'All items in cart';
          button.textContent = msg;
          button.style.backgroundColor = isStock ? '#d69e2e' : '#e53e3e';
          setTimeout(function() {
            button.textContent = originalText;
            button.style.backgroundColor = '';
            button.disabled = false;
          }, 2500);
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["series-gallery-inline"] && !Shopify.designMode) return;
  try {
    (function() {
    var WINDOW_SIZE = 31;
    var HALF_BEFORE = 15;

    document.querySelectorAll('.series-gallery-inline').forEach(function(gallery) {
      var slider = gallery.querySelector('[data-series-slider]');
      var track = gallery.querySelector('[data-series-track]');
      var prevBtn = gallery.querySelector('[data-series-prev]');
      var nextBtn = gallery.querySelector('[data-series-next]');
      if (!slider || !track) return;

      var currentId = gallery.dataset.currentProductId;
      var currentHandle = gallery.dataset.currentProductHandle;
      var seriesTotal = parseInt(gallery.dataset.seriesTotal, 10) || 0;
      var sectionId = gallery.dataset.sectionId;
      var windowSize = parseInt(gallery.dataset.windowSize, 10) || WINDOW_SIZE;

      function getThumbs() {
        return Array.from(track.querySelectorAll('.series-thumb'));
      }

      function findCurrentIndex(thumbs) {
        for (var i = 0; i < thumbs.length; i++) {
          if (thumbs[i].dataset.productId === currentId) return i;
        }
        return -1;
      }

      function computeWindow(currentIdx, total) {
        var start = currentIdx - HALF_BEFORE;
        var end = start + windowSize - 1;
        if (start < 0) {
          start = 0;
          end = Math.min(total - 1, windowSize - 1);
        }
        if (end > total - 1) {
          end = total - 1;
          start = Math.max(0, end - windowSize + 1);
        }
        return { start: start, end: end };
      }

      function applyWindow() {
        var thumbs = getThumbs();
        var currentIdx = findCurrentIndex(thumbs);
        if (currentIdx === -1) {
          var range = { start: 0, end: Math.min(thumbs.length - 1, windowSize - 1) };
          showRange(thumbs, range);
          return;
        }
        var range2 = computeWindow(currentIdx, thumbs.length);
        showRange(thumbs, range2);
        centerScroll();
      }

      function showRange(thumbs, range) {
        for (var i = 0; i < thumbs.length; i++) {
          if (i >= range.start && i <= range.end) {
            thumbs[i].classList.remove('series-thumb--hidden');
          } else {
            thumbs[i].classList.add('series-thumb--hidden');
          }
        }
        updateArrows();
      }

      function centerScroll() {
        var active = gallery.querySelector('.series-thumb--active:not(.series-thumb--hidden)');
        if (!active) return;
        var sliderRect = slider.getBoundingClientRect();
        var activeRect = active.getBoundingClientRect();
        var activeCenter = activeRect.left + activeRect.width / 2;
        var sliderCenter = sliderRect.left + sliderRect.width / 2;
        slider.scrollLeft += activeCenter - sliderCenter;
        updateArrows();
      }

      function updateArrows() {
        var atStart = slider.scrollLeft <= 1;
        var atEnd = slider.scrollLeft + slider.offsetWidth >= slider.scrollWidth - 1;
        if (prevBtn) prevBtn.disabled = atStart;
        if (nextBtn) nextBtn.disabled = atEnd;
      }

      function fetchPage(pageNum) {
        if (!sectionId) return Promise.resolve(null);
        var url = '/products/' + encodeURIComponent(currentHandle) + '?page=' + pageNum + '&section_id=' + encodeURIComponent(sectionId);
        return fetch(url, { credentials: 'same-origin' }).then(function(resp) {
          if (!resp.ok) return null;
          return resp.text();
        }).then(function(html) {
          if (!html) return null;
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          return doc.querySelector('[data-series-track]');
        }).catch(function() { return null; });
      }

      function loadedPages() {
        return (track.dataset.pageLoaded || '1').split(',').map(function(s) { return parseInt(s, 10); });
      }

      function markPageLoaded(pageNum) {
        var pages = loadedPages();
        if (pages.indexOf(pageNum) === -1) pages.push(pageNum);
        track.dataset.pageLoaded = pages.join(',');
      }

      function mergePage(otherTrack, pageNum) {
        if (!otherTrack) return;
        var newThumbs = otherTrack.querySelectorAll('.series-thumb');
        var existingIds = {};
        getThumbs().forEach(function(t) { existingIds[t.dataset.productId] = true; });
        var pageStartIndex = (pageNum - 1) * 50;
        var frag = document.createDocumentFragment();
        newThumbs.forEach(function(t) {
          if (existingIds[t.dataset.productId]) return;
          frag.appendChild(t);
        });
        if (pageNum > loadedPages()[0]) {
          track.appendChild(frag);
        } else {
          track.insertBefore(frag, track.firstChild);
        }
        markPageLoaded(pageNum);
      }

      function ensureLoaded() {
        var thumbs = getThumbs();
        var currentIdx = findCurrentIndex(thumbs);

        var needPage2 = false;
        if (seriesTotal > 50) {
          if (currentIdx === -1) {
            needPage2 = true;
          } else {
            var range = computeWindow(currentIdx, seriesTotal);
            if (range.end >= 50) needPage2 = true;
          }
        }

        var pages = loadedPages();
        if (needPage2 && pages.indexOf(2) === -1) {
          return fetchPage(2).then(function(other) {
            mergePage(other, 2);
            applyWindow();
          });
        }
        applyWindow();
        return Promise.resolve();
      }

      if (prevBtn) prevBtn.addEventListener('click', function() {
        slider.scrollTo({ left: slider.scrollLeft - slider.offsetWidth * 0.6, behavior: 'smooth' });
      });
      if (nextBtn) nextBtn.addEventListener('click', function() {
        slider.scrollTo({ left: slider.scrollLeft + slider.offsetWidth * 0.6, behavior: 'smooth' });
      });
      slider.addEventListener('scroll', updateArrows);

      ensureLoaded();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
